export function limitText(event, limit) {
  const text = event.target.value;
  const newText = text.slice(0, limit);
  return newText;
}
